<template>
  <div class="about-page">
    <!-- 页面头部 -->
    <section class="about-header">
      <div class="container">
        <h1>关于我们</h1>
        <p class="subtitle">专业医疗服务，呵护您的健康</p>
      </div>
    </section>

    <!-- 公司简介 -->
    <section class="company-intro">
      <div class="container">
        <div class="section-title">
          <h2>公司简介</h2>
          <div class="title-line"></div>
        </div>
        <div class="intro-content">
          <div class="intro-text">
            <p>
              康泰医疗健康集团成立于2015年，是一家专注于提供高品质医疗健康服务的综合性医疗机构。经过多年的稳健发展，我们已成为医疗健康领域的知名企业，拥有一支由资深医生、健康管理师和医疗技术人员组成的专业团队。
            </p>
            <p>
              自成立以来，我们始终坚持"以人为本，健康至上"的服务理念，致力于为客户提供全方位、个性化的健康管理服务。我们的服务涵盖健康体检、远程医疗咨询、慢病管理、健康评估等多个领域，已服务超过10万客户，赢得了广泛的信任和好评。
            </p>
            <p>
              展望未来，我们将继续引进先进的医疗设备和技术，加强专业团队建设，不断提升服务质量，致力于成为国内领先的健康管理服务提供商，为更多人的健康保驾护航。
            </p>
            <div class="company-stats">
              <div class="stat-item">
                <span class="stat-number">8+</span>
                <span class="stat-label">年医疗服务经验</span>
              </div>
              <div class="stat-item">
                <span class="stat-number">10万+</span>
                <span class="stat-label">服务客户</span>
              </div>
              <div class="stat-item">
                <span class="stat-number">100+</span>
                <span class="stat-label">专业医护团队</span>
              </div>
            </div>
          </div>
          <div class="intro-image">
            <img src="https://picsum.photos/id/96/800/600" alt="医疗中心环境" />
          </div>
        </div>
      </div>
    </section>

    <!-- 企业文化 -->
    <section class="company-culture">
      <div class="container">
        <div class="section-title">
          <h2>企业文化</h2>
          <div class="title-line"></div>
        </div>
        <div class="culture-content">
          <div class="culture-item">
            <div class="culture-icon">
              <i class="el-icon-star-on"></i>
            </div>
            <h3>企业愿景</h3>
            <p>
              成为国内领先的健康管理服务提供商，让每个人都能享受到专业、便捷的健康服务。
            </p>
          </div>
          <div class="culture-item">
            <div class="culture-icon">
              <i class="el-icon-flag"></i>
            </div>
            <h3>企业使命</h3>
            <p>
              以专业的医疗技术和贴心的服务，守护人们的健康，提高生活质量，共创健康未来。
            </p>
          </div>
          <div class="culture-item">
            <div class="culture-icon">
              <i class="el-icon-medal"></i>
            </div>
            <h3>核心价值观</h3>
            <p>专业严谨、关爱生命、诚信负责、创新进取、团队协作。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 我们的团队 -->
    <section class="our-team">
      <div class="container">
        <div class="section-title">
          <h2>医疗专家团队</h2>
          <div class="title-line"></div>
          <p class="section-desc">汇聚行业精英，为您的健康保驾护航</p>
        </div>
        <div class="team-members">
          <div
            class="team-member"
            v-for="(member, index) in teamMembers"
            :key="index">
            <div class="member-card">
              <img
                :src="`https://picsum.photos/id/${index + 220}/300/300`"
                :alt="member.name" />
              <div class="member-info">
                <h3>{{ member.name }}</h3>
                <p class="member-position">{{ member.position }}</p>
                <p class="member-desc">{{ member.description }}</p>
                <div class="member-social">
                  <a href="#" class="social-link"
                    ><i class="el-icon-chat-line-square"></i
                  ></a>
                  <a href="#" class="social-link"
                    ><i class="el-icon-chat-dot-square"></i
                  ></a>
                  <a href="#" class="social-link"
                    ><i class="el-icon-chat-round"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 发展历程 -->
    <section class="development-history">
      <div class="container">
        <div class="section-title">
          <h2>发展历程</h2>
          <div class="title-line"></div>
        </div>
        <div class="timeline">
          <div
            class="timeline-item"
            v-for="(item, index) in historyItems"
            :key="index"
            :class="{ 'timeline-right': index % 2 === 1 }">
            <div class="timeline-dot"></div>
            <div class="timeline-date">{{ item.year }}</div>
            <div class="timeline-content">
              <h3>{{ item.title }}</h3>
              <p>{{ item.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 医疗荣誉 -->
    <section class="company-honors">
      <div class="container">
        <div class="section-title">
          <h2>医疗荣誉</h2>
          <div class="title-line"></div>
        </div>
        <div class="honors-grid">
          <div class="honor-item" v-for="(honor, index) in honors" :key="index">
            <img
              :src="`https://picsum.photos/id/${index + 300}/400/300`"
              :alt="honor.title" />
            <h3>{{ honor.title }}</h3>
            <p>{{ honor.year }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section class="contact-us">
      <div class="container">
        <div class="contact-content">
          <div class="contact-info">
            <h2>联系我们</h2>
            <p>如果您有任何健康咨询需求或合作意向，欢迎随时联系我们</p>
            <div class="contact-details">
              <div class="contact-item">
                <i class="el-icon-map-marker"></i>
                <span>北京市海淀区医疗健康产业园A座5层</span>
              </div>
              <div class="contact-item">
                <i class="el-icon-phone"></i>
                <span>400-888-9999</span>
              </div>
              <div class="contact-item">
                <i class="el-icon-message"></i>
                <span>service@healthcare.com</span>
              </div>
              <div class="contact-item">
                <i class="el-icon-time"></i>
                <span>服务时间：周一至周日 8:00-20:00</span>
              </div>
            </div>
          </div>
          <div class="contact-image">
            <img
              src="https://picsum.photos/id/401/600/400"
              alt="医疗咨询中心" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "About",
  components: {},
  data() {
    return {
      teamMembers: [
        {
          name: "李医生",
          position: "首席医疗官",
          description: "哈佛大学医学博士，拥有20年临床经验，专精心血管疾病诊治",
        },
        {
          name: "王教授",
          position: "医学总监",
          description: "中国医学科学院研究员，专注于慢性病预防与健康管理研究",
        },
        {
          name: "张博士",
          position: "健康技术总监",
          description: "人工智能医学应用专家，负责医疗数据分析系统研发",
        },
        {
          name: "刘主任",
          position: "护理部主任",
          description: "资深护理专家，拥有丰富的临床护理和管理经验",
        },
      ],
      historyItems: [
        {
          year: "2015年",
          title: "康泰医疗成立",
          description: "在北京成立，致力于提供专业的健康管理服务",
        },
        {
          year: "2017年",
          title: "扩建医疗中心",
          description: "开设三家专业体检中心，服务网络逐步完善",
        },
        {
          year: "2019年",
          title: "引入智能医疗系统",
          description: "开发并应用健康云平台，实现数据化健康管理",
        },
        {
          year: "2021年",
          title: "全国服务网络建成",
          description: "在全国20个城市设立医疗服务点，年服务人数突破10万",
        },
      ],
      honors: [
        {
          title: "全国医疗服务质量金奖",
          year: "2022年",
        },
        {
          title: "健康管理创新企业奖",
          year: "2021年",
        },
        {
          title: "医疗AI应用优秀案例",
          year: "2020年",
        },
        {
          title: "消费者信赖医疗品牌",
          year: "2019年",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {},
};
</script>

<style scoped lang="less">
.container {
  width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

// 响应式设计
@media (max-width: 1200px) {
  .container {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .container {
    padding: 0 15px;
  }
}

// 页面头部
.about-header {
  background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
  color: #fff;
  padding: 100px 0;
  text-align: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100"><circle cx="20" cy="20" r="2" fill="rgba(255,255,255,0.2)"/><circle cx="80" cy="20" r="2" fill="rgba(255,255,255,0.2)"/><circle cx="20" cy="80" r="2" fill="rgba(255,255,255,0.2)"/><circle cx="80" cy="80" r="2" fill="rgba(255,255,255,0.2)"/><circle cx="50" cy="50" r="2" fill="rgba(255,255,255,0.2)"/></svg>');
    background-size: 100px;
  }

  h1 {
    font-size: 48px;
    margin-bottom: 20px;
    position: relative;
    font-weight: 600;
    letter-spacing: 1px;
  }

  .subtitle {
    font-size: 20px;
    opacity: 0.9;
    position: relative;
  }
}

// 通用标题样式
.section-title {
  text-align: center;
  margin-bottom: 60px;

  h2 {
    font-size: 32px;
    color: #333;
    margin-bottom: 15px;
    position: relative;
    display: inline-block;

    &::after {
      content: "";
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      width: 60px;
      height: 3px;
      background-color: #1890ff;
    }
  }

  .title-line {
    width: 100px;
    height: 2px;
    background-color: #1890ff;
    margin: 0 auto 20px;
  }

  .section-desc {
    font-size: 16px;
    color: #666;
    margin-top: 10px;
  }
}

// 公司简介
.company-intro {
  padding: 100px 0;

  .intro-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 60px;

    @media (max-width: 992px) {
      flex-direction: column;
      gap: 40px;
    }

    .intro-text {
      flex: 1;

      p {
        font-size: 16px;
        line-height: 1.8;
        color: #666;
        margin-bottom: 25px;
        text-align: justify;
      }

      .company-stats {
        display: flex;
        justify-content: space-around;
        margin-top: 40px;
        padding-top: 30px;
        border-top: 1px solid #eee;

        @media (max-width: 768px) {
          flex-direction: column;
          align-items: center;
          gap: 20px;
        }

        .stat-item {
          text-align: center;

          .stat-number {
            display: block;
            font-size: 36px;
            font-weight: 600;
            color: #1890ff;
            margin-bottom: 10px;
          }

          .stat-label {
            font-size: 14px;
            color: #666;
          }
        }
      }
    }

    .intro-image {
      flex: 1;

      img {
        width: 100%;
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
        transition: transform 0.3s;

        &:hover {
          transform: scale(1.02);
        }
      }
    }
  }
}

// 企业文化
.company-culture {
  background-color: #f8f9fa;
  padding: 100px 0;

  .culture-content {
    display: flex;
    justify-content: space-between;
    gap: 30px;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 25px;
    }

    .culture-item {
      flex: 1;
      background-color: #fff;
      padding: 40px 30px;
      border-radius: 12px;
      text-align: center;
      transition: all 0.3s ease;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);

      &:hover {
        transform: translateY(-10px);
        box-shadow: 0 15px 30px rgba(0, 0, 0, 0.12);
      }

      .culture-icon {
        font-size: 48px;
        color: #1890ff;
        margin-bottom: 25px;
        display: inline-block;
      }

      h3 {
        font-size: 20px;
        margin-bottom: 15px;
        color: #333;
        font-weight: 600;
      }

      p {
        font-size: 14px;
        color: #666;
        line-height: 1.6;
      }
    }
  }
}

// 我们的团队
.our-team {
  padding: 100px 0;

  .team-members {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 30px;

    .team-member {
      .member-card {
        background-color: #fff;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
        }

        img {
          width: 100%;
          height: 280px;
          object-fit: cover;
          border-radius: 12px 12px 0 0;
        }

        .member-info {
          padding: 25px;
          text-align: center;

          h3 {
            font-size: 20px;
            margin-bottom: 8px;
            color: #333;
          }

          .member-position {
            font-size: 14px;
            color: #1890ff;
            margin-bottom: 12px;
          }

          .member-desc {
            font-size: 14px;
            color: #666;
            line-height: 1.6;
            margin-bottom: 20px;
          }

          .member-social {
            display: flex;
            justify-content: center;
            gap: 15px;

            .social-link {
              font-size: 18px;
              color: #999;
              transition: color 0.3s;

              &:hover {
                color: #1890ff;
              }
            }
          }
        }
      }
    }
  }
}

// 发展历程
.development-history {
  background-color: #f0f8ff;
  padding: 100px 0;

  .timeline {
    position: relative;
    padding: 20px 0;
    margin: 0 auto;
    max-width: 800px;

    &::before {
      content: "";
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: 3px;
      height: 100%;
      background-color: #d9e8ff;
    }

    .timeline-item {
      position: relative;
      margin-bottom: 60px;
      padding: 0 30px;

      &.timeline-right {
        text-align: right;
      }

      .timeline-dot {
        position: absolute;
        left: 50%;
        top: 0;
        transform: translateX(-50%);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #1890ff;
        border: 4px solid #fff;
        box-shadow: 0 0 0 3px #d9e8ff;
        z-index: 1;
      }

      .timeline-date {
        font-size: 20px;
        font-weight: 600;
        color: #1890ff;
        margin-bottom: 10px;
      }

      .timeline-content {
        background-color: #fff;
        padding: 25px;
        border-radius: 12px;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);

        h3 {
          font-size: 18px;
          margin-bottom: 10px;
          color: #333;
        }

        p {
          font-size: 14px;
          color: #666;
          line-height: 1.6;
        }
      }
    }
  }
}

// 企业荣誉
.company-honors {
  padding: 100px 0;

  .honors-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 30px;

    .honor-item {
      background-color: #fff;
      border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
      transition: all 0.3s ease;
      text-align: center;
      padding: 20px;

      &:hover {
        transform: translateY(-8px);
        box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12);
      }

      img {
        width: 100%;
        height: 200px;
        object-fit: cover;
        border-radius: 8px;
        margin-bottom: 20px;
      }

      h3 {
        font-size: 18px;
        margin-bottom: 8px;
        color: #333;
      }

      p {
        font-size: 14px;
        color: #1890ff;
        font-weight: 500;
      }
    }
  }
}

// 联系我们
.contact-us {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4eaf0 100%);
  padding: 100px 0;

  .contact-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 60px;
    background-color: #fff;
    border-radius: 12px;
    padding: 60px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);

    @media (max-width: 992px) {
      flex-direction: column;
      gap: 40px;
      padding: 40px;
    }

    .contact-info {
      flex: 1;

      h2 {
        font-size: 28px;
        color: #333;
        margin-bottom: 20px;
      }

      p {
        font-size: 16px;
        color: #666;
        margin-bottom: 30px;
      }

      .contact-details {
        display: flex;
        flex-direction: column;
        gap: 20px;

        .contact-item {
          display: flex;
          align-items: center;
          gap: 15px;

          i {
            font-size: 20px;
            color: #1890ff;
          }

          span {
            font-size: 16px;
            color: #333;
          }
        }
      }
    }

    .contact-image {
      flex: 1;

      img {
        width: 100%;
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
      }
    }
  }
}
</style>
